<template>


<div>
    <b-modal  
    :no-close-on-esc="true"
     :no-close-on-backdrop="true"
      @shown="onShown()"
      :hide-header="true"
      :hide-footer="true"
      content-class="modal-blue"
      id="pre-reg-modal"
      size="xl"
      scrollable
      centered>
        <!-- Modal content-->
   
        <div class="row ">
          <div class="col mb-5 ">
            <h4 class="mb-4">{{$t('registration.preRegSubject')}}</h4>
            <center>
            <table>
              <tr v-for="(subject,i) of preRegSubjects" style="cursor:pointer" @click="handleclick(subject)">
                <td>{{subject.subject_code}} | {{  helpers.getLocalizedField(subject, 'subject')}}</td>
                <td>{{subject.day}} </td>
                <td>{{subject.Rooms}}</td>
                <td>{{subject.time?.split('.')[0]}}</td>
                <td>{{subject.Lectors}}</td>
              </tr>
            </table>
            </center>
                   
           

          </div>
        </div>
        <div class="row">
          <div class="col mt-0 pt-3 mt-sm-5 pt-sm-0 mb-3">
            <button type="button" class="btn btn-light-bold" @click="hideModal()">{{ $t('registration.close') }}</button>
          </div>
        </div>
    </b-modal>
     
  </div>





    </template>

    <script>
    export default{

        data(){

            return{

                preRegSubjects:[]

            }

        },

        
        methods:{

            hideModal() {
        this.$bvModal.hide('pre-reg-modal');
        this.$emit('closed'); 
        location.reload()
        
      },
      onShown(){

        this.$store.dispatch('registration/getAllPreRegSubjects').then(response=>{

                    this.preRegSubjects=response.data

                  


                    })



      },
      handleclick(subject){ 
 
          if(subject.can_not_deleted==0){

        this.$store.dispatch('registration/setpreRegSubject',{subject}) 
          } 
      }



        }



    }



</script>
<style scoped>
table ,tr,td{
  border: 1px solid white;
  border-collapse: collapse;
  padding: 10px;
}
</style>